import { render, staticRenderFns } from "./AccordionMenu.vue?vue&type=template&id=6d735df7&scoped=true"
import script from "./AccordionMenu.vue?vue&type=script&lang=js"
export * from "./AccordionMenu.vue?vue&type=script&lang=js"
import style0 from "./AccordionMenu.vue?vue&type=style&index=0&id=6d735df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d735df7",
  null
  
)

export default component.exports